module.exports = __webpack_public_path__ + "img/agromex.97880b62.jpg";